export const css = {
    root: '_240lYSDA',
    splash: '_38Ntn7IU',
    textContainer: '_2ApHram-',
    ' _key': 'afcpe-theme/afcpe/lcc-app/splash'
};
export default css;
